import * as yup from 'yup';

import { password } from '@/components/auth/forms/common.schema';

export const signupSchema = yup.object({
    email: yup.string().email('Must be a valid email').required('Required'),
    password: password.clone().required('Required'),
    firstname: yup.string().required('Required'),
    lastname: yup.string().required('Required'),
    countryCode: yup.string().required('Required'),
    company: yup.string().required('Required'),
    phoneNumber: yup.string().required('Required'),
});
